<template>
    <div class="w-100" >
  
      <ui-modal
        ref="modal"
        :title="'Editar Tipo Recargo - ' + code"
        transition="scale-up"
        size="large"
        @close="closeModalEvent()"
      >
        <recargos-form-type 
          :closeModal="cerrarModal"
          :showReset="false"
          :action="'update'"
        />
      </ui-modal>
    </div>
  </template>
  
  <script>
  // Common
  import { mapActions,mapState } from "vuex";
  
  import RecargosFormType from "./RecargosFormType";
  
  export default {
    
    data() {
      return {
        id:"",
        code:""
      };
    },
    methods: {
  
        ...mapActions(["ActionSetZindexTablaModal"]),
        ...mapActions("lineas", ["actionSetShowModalEditarRecargosType"]),
    
        openModal(ref) {
            this.ActionSetZindexTablaModal(true);
            this.$refs[ref].open();
        },
        closeModal(ref) {
            this.$refs[ref].close();
        },
        cerrarModal(){
            this.actionSetShowModalEditarRecargosType(false);
            this.ActionSetZindexTablaModal(false); 
            this.closeModal("modal");
        },
        closeModalEvent(){
          this.actionSetShowModalEditarRecargosType(false);
          this.ActionSetZindexTablaModal(false); 
        }
  
    },
    computed: {
      ...mapState("lineas", ["showModalEditarRecargosType",'dataEditarRecargoType']),
    },
    components: {
      RecargosFormType
    },
  
    watch: {
        showModalEditarRecargosType: function (_new) {
            _new && this.openModal("modal");
        },
        dataEditarRecargoType: function( _new){
          if (_new) {
            let me = this;
            me.id = _new.id;
            me.code = _new.code;
          }
        }
    },
  };
  </script>
  
  <style>
  
  </style>
  